export default "__VITE_ASSET__4b7b8d0b__"